export enum QAQCExecutionTypeEnum {
	IONIC_BALANCE = 'IONIC_BALANCE',
	ANOMALY_EVALUATION = 'ANOMALY_EVALUATION',
}
